//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MarkDialog',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      renewMaxDate: 30
    };
  },
  watch: {
    config: {
      handler: function handler(nVal) {
        if (nVal.mark) {
          this.rules.remarks = nVal.mark;
        }
      },
      deep: true
    }
  },
  methods: {
    getRenewDays: function getRenewDays(date) {
      return this.$moment(date).diff(this.$moment(new Date()), 'days');
    },
    getRenewName: function getRenewName(date, type) {
      var str = '';
      var days = this.getRenewDays(date);
      if (days > this.renewMaxDate) {
        str = type === 1 ? 'color-success' : '正常';
      } else if (days >= 0 && days <= this.renewMaxDate) {
        str = type === 1 ? 'color-warning' : '急需续费';
      } else {
        str = type === 1 ? 'color-danger' : '已超期';
      }
      return str;
    },
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.remarks = '';
    }
  }
};